// Polna · strona główna sklepu · lekki JS (bez bibliotek). Hero (loader + reveal) uruchamia osobny skrypt w <head>, 1:1 z anim-elva.
import * as Cart from 'polna/koszyk';

const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
document.documentElement.classList.add('js');

const fmt = (n, dec = 0) => n.toLocaleString('pl-PL', { minimumFractionDigits: dec, maximumFractionDigits: dec, useGrouping: 'always' }).replace(/\u00a0|\u202f/g, '\u00a0');
const zl = n => `${fmt(n)} zł`;
const STAR = '<svg viewBox="0 0 32 32"><use href="#i-star"/></svg>';
const stars = v => Array.from({ length: 5 }, (_, i) => i < Math.round(v) ? STAR : STAR.replace('<svg', '<svg class="off"')).join('');

/* oceny, opinie i pasek mediów renderuje Liquid (ustawienia motywu i metaobiekty, dane przykładowe do podmiany) */

/* ---------- odsłanianie sekcji (raz) ---------- */
const rvIO = new IntersectionObserver(es => es.forEach(e => {
  if (!e.isIntersecting) return;
  const sib = $$('.rv:not(.in)', e.target.parentElement);
  e.target.style.setProperty('--d', `${Math.min(sib.indexOf(e.target), 4) * 90}ms`);
  e.target.classList.add('in'); rvIO.unobserve(e.target);
}), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
$$('.rv').forEach(el => rvIO.observe(el));

/* ---------- leniwe tła sekcji ---------- */
const lazyIO = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('lazy-in'); lazyIO.unobserve(e.target); } }), { rootMargin: '250px 0px' });
$$('.coll, .news').forEach(el => lazyIO.observe(el));

/* ---------- ryciny jako osobny element (jak P1: .sec-art + is-in przy przewinięciu) ---------- */
const artIO = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); artIO.unobserve(e.target); } }), { rootMargin: '400px 0px' });
$$('.sec-art').forEach(el => artIO.observe(el));

/* ---------- paski ruchome: druga kopia grupy = pętla bez szwu (translateX -50%) ---------- */
$$('.mq').forEach(mq => {
  const track = $('.mq-track', mq), g = $('.mq-group', track);
  // grupa musi być szersza niż ekran, inaczej przy -50% powstałaby luka
  const minW = Math.max(innerWidth, 1600);
  const base = g.innerHTML; let guard = 0;
  while (g.scrollWidth < minW && guard++ < 6) g.insertAdjacentHTML('beforeend', base);
  const copy = g.cloneNode(true); copy.setAttribute('aria-hidden', 'true'); copy.querySelectorAll('[aria-label]').forEach(x => x.removeAttribute('aria-label'));
  track.appendChild(copy);
  const speed = Number(mq.dataset.speed || 40); // px/s
  track.style.setProperty('--mq-dur', `${Math.round(g.scrollWidth / speed)}s`);
});

/* ---------- menu na telefonie ---------- */
// v4: pełnoekranowe menu obsługuje assets/js/v4.js (#fmenu); stary panel zostaje tylko, gdy #fmenu nie istnieje
const menuBtn = $('[data-menu]'), links = $('#nav-links');
if (!$('#fmenu')) {
  menuBtn.addEventListener('click', () => { const on = links.classList.toggle('is-open'); menuBtn.setAttribute('aria-expanded', String(on)); });
  links.addEventListener('click', e => { if (e.target.closest('a')) { links.classList.remove('is-open'); menuBtn.setAttribute('aria-expanded', 'false'); } });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && links.classList.contains('is-open')) { links.classList.remove('is-open'); menuBtn.setAttribute('aria-expanded', 'false'); menuBtn.focus(); } });
}

/* ---------- FAQ: płynne otwieranie i zamykanie (details + grid 0fr/1fr) ---------- */
$$('.acc details').forEach(d => {
  const sum = $('summary', d);
  if (d.open) d.classList.add('is-open');
  sum.addEventListener('click', e => {
    e.preventDefault();
    if (reduce) { d.open = !d.open; d.classList.toggle('is-open', d.open); return; }
    if (!d.open) { d.open = true; requestAnimationFrame(() => requestAnimationFrame(() => d.classList.add('is-open'))); }
    else {
      d.classList.remove('is-open');
      const a = $('.acc-a', d);
      const done = ev => { if (ev && ev.target !== a) return; a.removeEventListener('transitionend', done); clearTimeout(t); if (!d.classList.contains('is-open')) d.open = false; };
      const t = setTimeout(done, 450); a.addEventListener('transitionend', done);
    }
  });
});

/* ---------- druga fotka kart (hover) dopiero, gdy karta jest w widoku ---------- */
const mIO = new IntersectionObserver(es => es.forEach(e => { if (!e.isIntersecting) return; $$('img[data-src]', e.target).forEach(i => { i.src = i.dataset.src; i.removeAttribute('data-src'); }); mIO.unobserve(e.target); }), { rootMargin: '100px 0px' });
$$('.card').forEach(c => mIO.observe(c));

/* ---------- liczniki (raz, 800 ms) ---------- */
function runCount(el) {
  const to = Number(el.dataset.to || 0), dec = Number(el.dataset.dec || 0), suf = el.dataset.suffix || '';
  if (reduce) { el.textContent = fmt(to, dec) + suf; return; }
  const t0 = performance.now(), D = 800;
  const step = t => { const k = Math.min(1, (t - t0) / D), e = 1 - Math.pow(1 - k, 3);
    el.textContent = fmt(dec ? Math.round(to * e * 10) / 10 : Math.round(to * e), dec) + (k === 1 ? suf : '');
    if (k < 1) requestAnimationFrame(step); };
  requestAnimationFrame(step);
}
const cIO = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { runCount(e.target); cIO.unobserve(e.target); } }), { threshold: 0.6 });
$$('[data-count]').forEach(el => { el.textContent = fmt(0, Number(el.dataset.dec || 0)); cIO.observe(el); });


/* ---------- filtry produktów ---------- */
$$('[data-filter]').forEach(b => b.addEventListener('click', () => {
  const f = b.dataset.filter;
  $$('[data-filter]').forEach(x => x.setAttribute('aria-selected', String(x === b)));
  $$('[data-grid] .card').forEach(c => {
    const show = f === 'all' ? c.dataset.id !== 'sub' : c.dataset.cat === f;
    if (show && c.hidden) { c.hidden = false; c.classList.add('in'); if (!reduce) { c.classList.remove('fading'); void c.offsetWidth; c.classList.add('fading'); } }
    else if (!show) c.hidden = true;
  });
}));

/* ---------- warianty kolorem w kartach ---------- */
$$('.card .swatches').forEach(g => g.addEventListener('click', e => {
  const b = e.target.closest('[data-sw]'); if (!b) return;
  const card = g.closest('.card'); card.dataset.variant = b.dataset.sw;
  $$('[data-sw]', g).forEach(x => x.setAttribute('aria-checked', String(x === b)));
  const lab = $('[data-sw-label]', g);
  if (card.dataset.id === 'sub') lab.textContent = b.dataset.sw === 'green' ? 'Start: sudoku' : 'Start: krzyżówki';
  else lab.textContent = b.dataset.sw === 'green' ? 'Sudoku, zielony' : 'Krzyżówki, bordowy';
  Cart.ready.then(() => { const p = Cart.product(card.dataset.handle); const a = card.querySelector('[data-add-handle]'); if (p && a) a.dataset.variant = p.variants[b.dataset.sw === 'bordo' ? 1 : 0].id; });
}));

/* ---------- kolekcja: przełączanie tomu (efekt P1) ---------- */
const TOMY = (() => { try { return JSON.parse($('script[data-toms]')?.textContent || '{}'); } catch { return {}; } })();
const coll = $('.coll'); if (coll) {
const info = $('[data-tom-info]'), tomAdd = $('[data-tom-add]');
let tomTimer;
function setTom(t) {
  if (coll.dataset.tom === String(t)) return;
  coll.dataset.tom = String(t); coll.classList.add('lazy-in');
  $$('[data-tom-btn]').forEach(b => b.setAttribute('aria-selected', String(b.dataset.tomBtn === String(t))));
  const d = TOMY[t];
  const apply = () => {
    for (const k of ['kind', 'name', 'latin', 'desc', 'price']) $(`[data-f="${k}"]`, info).textContent = d[k];
    $('[data-f="link"]', info).href = d.link;
    if (!d.add) $('[data-f="link"]', info).href = '#news-h';
    $('[data-f="link"]', info).textContent = d.add ? (coll.dataset.lblSee || 'Zobacz tom') : (coll.dataset.lblNotify || 'Powiadom mnie');
    tomAdd.hidden = !d.add; tomAdd.dataset.add = d.add || '';
    info.classList.remove('swap');
  };
  clearTimeout(tomTimer);
  if (reduce) { apply(); return; }
  info.classList.add('swap'); tomTimer = setTimeout(apply, 260);
}
$$('[data-tom-btn]').forEach(b => b.addEventListener('click', () => setTom(b.dataset.tomBtn)));
$('.toms').addEventListener('keydown', e => {
  if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
  const n = ((Number(coll.dataset.tom) - 1 + (e.key === 'ArrowRight' ? 1 : 2)) % 3) + 1;
  setTom(n); $(`[data-tom-btn="${n}"]`).focus();
});
tomAdd.dataset.add = TOMY[1]?.add || '';
}

/* ---------- koszyk: wspólny moduł koszyk.js (localStorage), ten sam na wszystkich stronach ---------- */
const HANDLE = { tom1: 'tom-i-sudoku', tom2: 'tom-ii-krzyzowki', komplet: 'komplet', prezent: 'zestaw-prezentowy', sub: 'subskrypcja' };
function add(id, src) {
  const handle = HANDLE[id] || id; if (!handle) return;
  const card = src?.closest?.('.card');
  const bordo = card?.dataset.variant === 'bordo';
  const p = Cart.product(handle); if (!p) return;
  const vid = p.variants.length > 1 ? p.variants[bordo ? 1 : 0].id : p.variants[0].id;
  let plan = null;
  if (id === 'sub') plan = src?.closest?.('[data-sub-form]') ? ($('[data-sub-form] input[name="freq"]:checked')?.value || '28') : '28';
  Cart.add({ handle, variant_id: vid, selling_plan: plan });
  if (src?.classList?.contains('add')) { src.classList.add('done'); const l0 = src.textContent; src.textContent = src.dataset.done || 'Dodano'; setTimeout(() => { src.classList.remove('done'); src.textContent = l0; }, 1600); }
}
document.addEventListener('click', e => {
  const a = e.target.closest('[data-add]'); if (a && a.dataset.add) { e.preventDefault(); Cart.ready.then(() => add(a.dataset.add, a)); }
});

/* newsletter: formularz Shopify {% form 'customer' %}, bez przechwytywania JS */
